import { render } from "./Dev.vue?vue&type=template&id=686b48df&scoped=true"
import script from "./Dev.vue?vue&type=script&lang=js"
export * from "./Dev.vue?vue&type=script&lang=js"

import "./Dev.vue?vue&type=style&index=0&id=686b48df&scoped=true&lang=css"

import exportComponent from "/home/nathan/Documentos/Creditall/Desenvolvimento/projetos/creditall/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686b48df"]])

export default __exports__